import { createFileRoute } from '@tanstack/react-router';
import Loading from '@/components/common/loading.tsx';
import { useEffect } from 'react';
import { reactivateMember } from '@/lib/members';
import Bugsnag from '@bugsnag/js';
import { useMember } from '@/lib/members/hooks/useMember.ts';
import { ACCOUNT_REACTIVATION_CLUB_ID } from '@/lib/config.ts';

export const Route = createFileRoute('/_checkAuth/reactivar-cuenta_/callback')({
  component: () => <RouteComponent />,
});

function RouteComponent() {
  const { isLoading, member } = useMember();

  useEffect(() => {
    console.debug('Checking if user is authenticated for reactivation callback...');

    if (isLoading) {
      console.debug('User data is still loading, waiting...');
      return;
    }

    if (member) {
      console.debug('User is authenticated. Reactivating member...');

      if (!member.MemberId) {
        console.debug('Member is not yet fully registered, redirecting to asociate page...');
        window.location.replace(`/asociate?club_id=${ACCOUNT_REACTIVATION_CLUB_ID}`);
        return;
      }

      console.debug('Reactivating member with ID:', member.MemberId);

      reactivateMember()
        .then(() => {
          console.debug('Reactivated user member');
          window.location.replace('/miembros?reactivated=true');
        })
        .catch((e) => {
          console.error(e);
          Bugsnag.notify(e);
          window.location.replace('/');
        });
    } else {
      console.debug('User is not authenticated. Redirecting to home...');
      window.location.replace('/');
    }
  }, [isLoading, member]);

  return <Loading />;
}
